import {IntlShape} from "react-intl";
import router from "@/routing/Router";
import {AuthPagePresetFrameProps} from "peggirkit";
import React from "react";
import AuthenticationPageLogo from "@widgets/auth/AuthenticationPageLogo";
import AuthenticationPageFooter from "@widgets/auth/AuthenticationPageFooter";

export const authPageProps = (titleMsgId: string, intl: IntlShape): Omit<AuthPagePresetFrameProps, "title"> => ({
    appName: intl.formatMessage({id: "appName"}),
    onSignedInRedirectTo: router.index.absolutePath(),
    desktopBreakpoint: "md",
    header: <AuthenticationPageLogo titleMsgId={titleMsgId}/>,
    pageFooter: <AuthenticationPageFooter/>,
});